// extracted by mini-css-extract-plugin
var _1 = "abc-details___WziIt";
var _2 = "#68914d";
var _3 = "#9cc681";
var _4 = "#8ab46f";
var _5 = "8px";
var _6 = "6px";
var _7 = "8px";
var _8 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _9 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _a = "10px";
var _b = "#e8e8e8";
var _c = "16px 24px";
var _d = "cell___Cu2uh";
var _e = "#38aa73";
var _f = "#956c22";
var _10 = "#2988bd";
var _11 = "#eee";
var _12 = "#c4842d";
var _13 = "#b8567c";
var _14 = "#8b6e4e";
var _15 = "#5889c2";
var _16 = "#4e8a8a";
var _17 = "#6a8a3e";
var _18 = "#7b5ea7";
var _19 = "#4a6fa5";
var _1a = "#3a8a6e";
var _1b = "#c25b4e";
var _1c = "#fafbfc";
var _1d = "#1e3050";
var _1e = "#293d62";
var _1f = "#fafbfc";
var _20 = "rgba(0,0,0,.12)";
var _21 = "#d9d9d9";
var _22 = "rgba(5,5,5,.1)";
var _23 = "#eaf2fc";
var _24 = "rgba(0,0,0,.65)";
var _25 = "#ebebeb";
var _26 = "#068467";
var _27 = "rgba(6,132,103,.1)";
var _28 = "#dc4949";
var _29 = "rgba(220,73,73,.1)";
var _2a = "#787c81";
var _2b = "#d6d9dc";
var _2c = "#f3f5f7";
var _2d = "#73c9b2";
var _2e = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2f = "#b8e7da";
var _30 = "#5357f8";
var _31 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _32 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _33 = "#f7f8f9";
var _34 = "#edeeef";
var _35 = "#7b8996";
var _36 = "#ededed";
var _37 = "#f4f5f7";
var _38 = "#fbfbfc";
var _39 = "rgba(0,0,0,.75)";
var _3a = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3b = "rgba(0,0,0,.3)";
var _3c = "rgba(0,0,0,.5)";
var _3d = "rgba(0,0,0,.4)";
var _3e = "rgba(0,0,0,.95)";
var _3f = "rgba(0,0,0,.65)";
var _40 = "rgba(0,0,0,.85)";
var _41 = "20px";
var _42 = "#f41e28";
var _43 = "1063px";
var _44 = "divider___b4fEz";
var _45 = "rgba(227,89,86,.2)";
var _46 = "#e35956";
var _47 = "16px 24px";
var _48 = "28px";
var _49 = "32px";
var _4a = "18px";
var _4b = "14px";
var _4c = "14px";
var _4d = "15px";
var _4e = "12.6px";
var _4f = "11px";
var _50 = "20px";
var _51 = "28px";
var _52 = "700";
var _53 = "200";
var _54 = "300";
var _55 = "500";
var _56 = "400";
var _57 = "600";
var _58 = "hsla(0,0%,100%,.2)";
var _59 = "#ccc";
var _5a = "49px";
var _5b = "icon___eLy2r";
var _5c = "5px";
var _5d = "#5357f8";
var _5e = "rgba(0,0,0,.4)";
var _5f = "observation___qru4i";
var _60 = "over-active-budget___eIfJW";
var _61 = "over-base-budget___wAihU";
var _62 = "over-budget___OUDiO";
var _63 = "percentage___EGmvH";
var _64 = "#fafafa";
var _65 = "hsla(0,0%,100%,.9)";
var _66 = "progress-bar____DFGV";
var _67 = "15px";
var _68 = "20px";
var _69 = "24px";
var _6a = "hsla(0,0%,100%,.6)";
var _6b = "#7e7eff";
var _6c = "hsla(0,0%,100%,.7)";
var _6d = "hsla(0,0%,100%,.3)";
var _6e = "hsla(0,0%,100%,.575)";
var _6f = "60px";
var _70 = "208px";
var _71 = "spend-info___WP32x";
var _72 = "status-text___FbTJb";
var _73 = "rgba(82,196,26,.2)";
var _74 = "#52c41a";
var _75 = "12px";
var _76 = "20px";
var _77 = "tooltip___tA8Am";
var _78 = "under-budget___IamSP";
var _79 = "updated-at___jsFTz";
var _7a = "rgba(250,173,20,.2)";
var _7b = "#faad14";
var _7c = "#fff";
var _7d = "hsla(0,0%,100%,.2)";
export { _1 as "abc-details", _2 as "actionButtonColorDark", _3 as "actionButtonColorLight", _4 as "actionButtonColorMedium", _5 as "borderRadiusCard", _6 as "borderRadiusMain", _7 as "borderRadiusSurface", _8 as "boxShadowInnerXs", _9 as "boxShadowXl", _a as "btnRightMargin", _b as "cardBorderColor", _c as "cardPadding", _d as "cell", _e as "changeSetCompletedColor", _f as "changeSetManuallyChangesProposed", _10 as "changeSetScheduledChangesProposed", _11 as "chipBackground", _12 as "colorAccentAmber", _13 as "colorAccentBerry", _14 as "colorAccentBrown", _15 as "colorAccentCornflower", _16 as "colorAccentCyan", _17 as "colorAccentOlive", _18 as "colorAccentPurple", _19 as "colorAccentSteelBlue", _1a as "colorAccentTeal", _1b as "colorAccentTerracotta", _1c as "colorBackgroundMain", _1d as "colorBackgroundSidebar", _1e as "colorBackgroundSidebarHover", _1f as "colorBackgroundTabs", _20 as "colorBorderContainer", _21 as "colorBorderMain", _22 as "colorBorderSecondary", _23 as "colorDeltaCyanBlueBg", _24 as "colorDeltaGray", _25 as "colorDeltaGrayBg", _26 as "colorDeltaGreen", _27 as "colorDeltaGreenBg", _28 as "colorDeltaRed", _29 as "colorDeltaRedBg", _2a as "colorDetailsFieldText", _2b as "colorDetailsIcon", _2c as "colorDetailsTagBg", _2d as "colorMint", _2e as "colorMintGradient", _2f as "colorMintLight", _30 as "colorPrimary", _31 as "colorPrimaryHover", _32 as "colorPrimaryLightened", _33 as "colorTableHeadBg", _34 as "colorTableHeadBgHover", _35 as "colorTableHeadSubtitle", _36 as "colorTableRowBorder", _37 as "colorTableTextBg", _38 as "colorTableTotalRowBg", _39 as "colorTextBase", _3a as "colorTextDisabled", _3b as "colorTextExtraLight", _3c as "colorTextLight", _3d as "colorTextLighter", _3e as "colorTextMainHeading", _3f as "colorTextMuted", _40 as "colorTextPrimary", _41 as "contentHorizPadding", _42 as "dangerColor", _43 as "dashboardPdfContentWidth", _44 as "divider", _45 as "errorBackcolor", _46 as "errorColor", _47 as "filterPanelPadding", _48 as "filtersDefaultHeight", _49 as "filtersTallHeight", _4a as "fontSizeLarge", _4b as "fontSizeMain", _4c as "fontSizeMedium", _4d as "fontSizePlus", _4e as "fontSizeSmaller", _4f as "fontSizeSmallest", _50 as "fontSizeXLarge", _51 as "fontSizeXxLarge", _52 as "fontWeightBold", _53 as "fontWeightExtraLight", _54 as "fontWeightLight", _55 as "fontWeightMediumBold", _56 as "fontWeightNormal", _57 as "fontWeightSemiBold", _58 as "ghostWhite", _59 as "grayBackgroundColor", _5a as "headerHeight", _5b as "icon", _5c as "iconHorizontalMargin", _5d as "linkColor", _5e as "linkColorMuted", _5f as "observation", _60 as "over-active-budget", _61 as "over-base-budget", _62 as "over-budget", _63 as "percentage", _64 as "popoverHeaderColor", _65 as "popoverMaskColor", _66 as "progress-bar", _67 as "rowPadding", _68 as "ruleInnerGutters", _69 as "ruleSideGutters", _6a as "sideMenuIconColor", _6b as "sideMenuIconSelectedColor", _6c as "sideMenuItemColor", _6d as "sideMenuScrollbarThumbColor", _6e as "sideMenuSubmenuItemColor", _6f as "sidebarCollapsedWidth", _70 as "sidebarWidth", _71 as "spend-info", _72 as "status-text", _73 as "successBackcolor", _74 as "successColor", _75 as "tableHeaderVerticalPadding", _76 as "tableHorizPadding", _77 as "tooltip", _78 as "under-budget", _79 as "updated-at", _7a as "warningBackcolor", _7b as "warningColor", _7c as "whiteColor", _7d as "whiteDividerColor" }
